export const defaultState = {
  id: null,
  certificateHolder: null,
  certificateLevelDomain: null,
  certificationBody: null,
  issueDate: null,
  type: null,
  validUntil: null,
  certId: '',
  holderAuthorized: null,
  visibility: null,
  otherSignatures: [],
  headSignature: null,
  assessorSignature: null,
  signatureOptions: [],
  language: null,
  fullHeadSignature: null,
  fullAssessorSignature: null,
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    const headSignature =
      action.payload.signatures?.find((signature) => signature.assessorType === 'H') || null;
    const assessorSignature =
      action.payload.signatures?.find((signature) => signature.assessorType === 'S') || null;
    const otherSignatures =
      action.payload.signatures
        ?.filter((signature) => signature.assessorType === 'O')
        ?.map((signature) => signature.user?.id || signature.userId)
        ?.filter(Boolean) || [];

    return {
      ...state,
      ...action.payload,
      certificateHolder: action.payload.certificateHolder?.id,
      certificateLevelDomain: action.payload.levelDomain?.id,
      certificationBody: action.payload.certificationBody?.id,
      issueDate: action.payload.issueDate ? new Date(action.payload.issueDate) : undefined,
      validUntil: action.payload.validUntil ? new Date(action.payload.validUntil) : undefined,
      birthDate: action.payload.birthDate ? new Date(action.payload.birthDate) : undefined,
      organization: action.payload.organization?.id,
      memberAssociation: action.payload.memberAssociation?.id,
      headSignature: headSignature?.user?.id || headSignature?.userId,
      assessorSignature: assessorSignature?.user?.id || assessorSignature?.userId,
      otherSignatures: otherSignatures,
      language: action.payload.language?.id,
      fullHeadSignature: headSignature,
      fullAssessorSignature: assessorSignature,
    };
  }

  if (action.type === UPDATE_FIELD) {
    if (action.payload.name === 'issueDate') {
      const newValidUnitil = new Date(action.payload.value);
      newValidUnitil.setFullYear(newValidUnitil.getFullYear() + 5);
      newValidUnitil.setDate(newValidUnitil.getDate() - 1);
      return { ...state, [action.payload.name]: action.payload.value, validUntil: newValidUnitil };
    }
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
